import { render, staticRenderFns } from "./PurchaseRequestDetail.vue?vue&type=template&id=6adc8d00&scoped=true&"
import script from "./PurchaseRequestDetail.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRequestDetail.vue?vue&type=style&index=0&id=6adc8d00&prod&lang=scss&scoped=true&"
import style1 from "./PurchaseRequestDetail.vue?vue&type=style&index=1&id=6adc8d00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adc8d00",
  null
  
)

export default component.exports